import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

/**
 * Small, read-only helper text shown under a form field. `example` values are
 * always rendered as clearly fictitious samples (prefixed « ex. : »), never as
 * official rates or instructions.
 */
export function FieldHelp({
  children,
  example,
  className,
}: {
  children?: ReactNode;
  example?: ReactNode;
  className?: string;
}): JSX.Element | null {
  if (!children && !example) return null;
  return (
    <p className={cn('mt-1 text-xs leading-relaxed text-slate-500', className)}>
      {children}
      {children && example ? ' ' : null}
      {example ? <span className="italic text-slate-400">ex.&nbsp;: {example}</span> : null}
    </p>
  );
}
